module.exports = {
    TEXT_TALK: "Let's Talk",
    TEXT_REQUEST_CUSTOM_SERVICE :"Request Custom Service",
    TEXT_MORE_NEWS: "More News",
    TEXT_READ_MORE: 'Read More',
    TEXT_VIEW_MORE: 'View More',
    TEXT_EXPLORE_PROJECT: 'Explore Project',
}